import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import AboutFeature from "../pages/Sheets/about-feature";
import AboutJumbotron from "../pages/Sheets/about-jumbotron";
import AboutMission from "../pages/Sheets/about-mission";
import AboutTestimonial from "../pages/Sheets/about-testimonial";
import AboutUs from "../pages/Sheets/about-us";

export default function PageAbout() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <AboutJumbotron />
      <AboutUs />
      <AboutFeature />
      <AboutMission />
      <AboutTestimonial />
      <Footer />
    </>
  );
}
